import Link from "next/link";
import { ChevronDownIcon } from "lucide-react";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import { memo } from "react";

type LinkItem = {
  label: string;
  href?: string;
};

type FooterAccordionSectionProps = {
  value: string;
  label: string;
  links: LinkItem[];
  isTablet: boolean | undefined;
};

const FooterAccordionSection = ({
  value,
  label,
  links,
  isTablet,
}: FooterAccordionSectionProps) => {
  const triggerClass = cn(
    "group cursor-pointer text-lg leading-[150%] flex justify-between text-background [&>svg]:!text-background py-[10.5] md:hidden"
  );

  const staticLabelClass = cn(
    "flex justify-between text-lg leading-[150%] font-semibold cursor-pointer hover:underline text-background py-[10.5] md:text-white md:py-0 md:text-xl md:leading-[150%]"
  );

  const contentClass = cn(
    "p-0 grid grid-cols-1 pl-4 text-sm leading-[18px] md:leading-[19px] md:grid md:grid-cols-1 md:gap-4 md:pl-0 md:!grid",
    { hidden: isTablet === undefined }
  );

  return (
    <AccordionItem
      value={value}
      className="grid grid-cols-1 md:gap-4 lg:gap-6 border-0 place-content-start"
    >
      {isTablet === false ? (
        <AccordionTrigger className={triggerClass}>
          <span className="font-semibold">{label}</span>
        </AccordionTrigger>
      ) : (
        <span className={staticLabelClass}>
          {label}
          <ChevronDownIcon
            width={24}
            height={24}
            className="shrink-0 md:hidden"
          />
        </span>
      )}
      <AccordionContent
        {...(isTablet === false ? {} : { forceMount: true })}
        className={contentClass}
      >
        {links.map(({ label, href }) => (
          <span
            key={label}
            className="cursor-pointer hover:underline my-[11px] md:my-0"
          >
            {href ? <Link href={href}>{label}</Link> : label}
          </span>
        ))}
      </AccordionContent>
    </AccordionItem>
  );
}

export default memo(FooterAccordionSection);
